import { getPropertyOf } from '@cs/core/utils';
import { KeyValuePair }  from '../.././data-described/key-value-pair.model';


export class DataLookup<TKey = unknown, TValue = unknown> {

	id: string;
	values: KeyValuePair<TKey, TValue>[];

	constructor(init: DataLookup<TKey, TValue>) {
		this.id     = getPropertyOf(init, 'id');
		this.values = getPropertyOf(init, 'values');
	}

}
